import script from "./Badge.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badge.vue?vue&type=script&lang=ts&setup=true"

import "./Badge.vue?vue&type=style&index=0&id=7b3c8ad8&lang=less"

const __exports__ = script;

export default __exports__